import { REQUEST, FILTER, RESPONSE, SELECT, INVALIDATE, UPDATE_VALUE, RESET } from './DetailActions';

/**
 * Implicitní funkce pro načtení data key.
 * @returns {*|null|number|string}
 */
function getDataKey(this: typeof initialState) {
    let dataKey = '';

    // Filter
    dataKey += JSON.stringify(this.filter);

    // Parent id
    dataKey += '_' + this.id;

    // ---

    return dataKey;
}

const initialState = {
    data: null,
    id: null,
    isFetching: false,
    fetched: false,
    currentDataKey: '',
    filter: {}, // pokud je detai zobrazován na základě filtru
    getDataKey,
    reducer: detail,
};

export default function detail(state = initialState, action: {type?: string, dataKey?: string, data?: any, id?: any, filter?: any} = {}, config?: {filter?: any}) {
    // Konfigurace
    if (config) {
        state = {...state};

        if (config.filter) {    // inicializační filtr
            state.filter = config.filter;
        }
    }

    switch (action.type) {
        case REQUEST:
            return {
                ...state,
                isFetching: true,
                currentDataKey: action.dataKey,
            };
        case RESPONSE: {
            return {
                ...state,
                isFetching: false,
                fetched: true,
                data: action.data,
            };
        }
        case FILTER: {
            return {
                ...state,
                filter: action.filter,
            };
        }
        case SELECT: {
            return {
                ...state,
                id: action.id,
                data: state.id === action.id ? state.data : null,
                fetched: state.id === action.id ? state.fetched : false,
            };
        }
        case INVALIDATE: {
            if (action.id === state.id) {
                return {
                    ...state,
                    currentDataKey: initialState.currentDataKey,
                };
            } else {
                return state;
            }
        }
        case UPDATE_VALUE: {
            return {
                ...state,
                data: action.data,
            };
        }
        case RESET: {
            return {
                ...initialState,
                filter: config && config.filter ? config.filter : initialState.filter,
            };
        }
        default:
            return state;
    }
}
